import { TranslateService } from '@ngx-translate/core';
import { catchError, of } from 'rxjs';

export const DEFAULT_LANGUAGE = 'en';

// mat-select copies the selected option's text into its trigger once, so a view
// rendered before the translations land keeps the empty label.
export function initializeTranslations(translate: TranslateService) {
  return () => translate.use(DEFAULT_LANGUAGE).pipe(catchError(() => of(null)));
}
